var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#999",
    fill: "currentColor",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.377 13.692h.773l4.85 4.86L18.552 20l-4.86-4.85v-.768l-.268-.268a6.28 6.28 0 01-4.106 1.522 6.318 6.318 0 116.318-6.318c0 1.57-.574 3.003-1.527 4.107l.268.267zM4.944 9.318a4.374 4.374 0 108.748 0 4.374 4.374 0 00-8.748 0z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.efb95005abd5e6341f55e16958899127.svg";
export { ForwardRef as ReactComponent };